var _defs, _rect, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultavatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blobGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3B82F6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#3B82F6;#8B5CF6;#3B82F6",
    dur: "8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06B6D4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#06B6D4;#EC4899;#06B6D4",
    dur: "8s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "leftEyeClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 85,
    r: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rightEyeClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 85,
    r: 10
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,40 C130,10 170,80 160,120 C150,160 90,180 50,150 C10,120 30,70 80,40",
    fill: "url(#blobGradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M80,40 C130,10 170,80 160,120 C150,160 90,180 50,150 C10,120 30,70 80,40;               M85,45 C135,20 165,85 155,125 C145,165 85,175 45,145 C15,115 35,75 85,45;               M80,40 C130,10 170,80 160,120 C150,160 90,180 50,150 C10,120 30,70 80,40",
    dur: "10s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 85,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 85,
    r: 5,
    fill: "#1F2937"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "85;85;83;85",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 75,
    width: 20,
    height: 20,
    fill: "white",
    clipPath: "url(#leftEyeClip)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0;0;20;0;0",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "85;85;75;85;85",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 85,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 85,
    r: 5,
    fill: "#1F2937"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "85;85;83;85",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 75,
    width: 20,
    height: 20,
    fill: "white",
    clipPath: "url(#rightEyeClip)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0;0;20;0;0",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "85;85;75;85;85",
    dur: "5s",
    repeatCount: "indefinite"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115 Q100 130 115 115",
    stroke: "white",
    strokeWidth: 4,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M85 115 Q100 130 115 115;               M85 118 Q100 138 115 118;               M85 115 Q100 130 115 115",
    dur: "8s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultavatar);
export default __webpack_public_path__ + "static/media/defaultavatar.f8ae73df5d6924ac8098fb864f74e1fe.svg";
export { ForwardRef as ReactComponent };